export const cookie_to_object = (cookies?: string) => cookies ? Object.fromEntries(cookies
	.split(`; `)
	.filter(Boolean)
	.map((cookie: string) => {
		const [ key, ...value ] = cookie.split(`=`)

		return [ key, value.join(`=`) ]
	})
) : {}

export const object_to_cookie = (object: object) => object ? Object.entries(object)
	.map(([ key, value ]: [ string, string ]) => `${ key }=${ value }`)
	.join(`; `) : ``

